const {h, render, Component} = require('preact');

class Acknowledge extends Component {
  constructor(props) {
    super(props);
  }

  showCoolingOffAck() {
    let isRefundAfterCoolingOff = this.props.order.metadata.isRefundAfterCoolingOff;
    let disableSRTRefundMsg = this.props.order.disableSRTRefundMsg;
    if (isRefundAfterCoolingOff && !disableSRTRefundMsg) {
      return (
        <div class="confirm-cooling-off-msg"> {I18n.translate("js.modules.web_2018.refund_after_cooling_period")} </div>
      )
    }
  }

  render() {
    return (
      <div>
        <input type="checkbox" value="true" id="refund-message" name="refund-message" onClick={this.props.handleClick}> </input>
        <label for="refund-message">
          <div class="confirm-message"> {I18n.translate("js.modules.support.refund_confirm_message")}
          </div>
        </label>
        {this.showCoolingOffAck()}
      </div>
    )
  }
}

module.exports = Acknowledge
